interface LogoProps {
  className?: string;
  imgClassName?: string;
}

// Marca do Se Liga Católico — arquivo transparente do projeto.
export default function Logo({
  className = '',
  imgClassName = 'h-10 w-auto object-contain md:h-11',
}: LogoProps) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src="https://public.readdy.ai/ai/img_res/77b56331-3f77-4130-b8d0-3ffb55998259.png"
        alt="Se Liga Católico"
        title="Se Liga Católico"
        className={imgClassName}
      />
    </span>
  );
}